// The textarea gives us the whole text after each input; the CRDT wants an edit. One input event
// changes one contiguous range (typing, deleting, pasting, autocorrect), so the common prefix and
// suffix are enough. `cursor` breaks ties in repeated text ("aa" → "aaa": which "a" was typed?).

export type Splice = { at: number; del: number; insert: string };

export function diff(before: string, after: string, cursor = after.length): Splice | null {
  if (before === after) return null;
  const max = Math.min(before.length, after.length);
  const added = after.length - before.length;
  // The edit ends at the cursor; the prefix cannot extend past where the inserted text begins.
  let start = 0;
  const startLimit = Math.min(max, Math.max(0, added > 0 ? cursor - added : cursor));
  while (start < startLimit && before[start] === after[start]) start++;
  let end = 0;
  while (end < max - start && before[before.length - 1 - end] === after[after.length - 1 - end]) end++;
  return { at: start, del: before.length - start - end, insert: after.slice(start, after.length - end) };
}

export function applySplice(text: string, s: Splice): string {
  return text.slice(0, s.at) + s.insert + text.slice(s.at + s.del);
}
